"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndUser = void 0;

var EndUser =
/** @class */
function () {
  function EndUser(meta) {
    this.$user = meta;
  }

  Object.defineProperty(EndUser.prototype, "id", {
    /**
     * The UUID referencing the user's record stored in Flatfile
     */
    get: function get() {
      return this.$user.id;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EndUser.prototype, "userId", {
    /**
     * Your internal ID reference for this user (required)
     */
    get: function get() {
      return this.$user.userId;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EndUser.prototype, "name", {
    /**
     * The user's full name if you provided it
     */
    get: function get() {
      return this.$user.name;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EndUser.prototype, "email", {
    /**
     * The user's email if you provided it
     */
    get: function get() {
      return this.$user.name;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EndUser.prototype, "companyName", {
    /**
     * The company name the user is currently operating under
     */
    get: function get() {
      return this.$user.companyName;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EndUser.prototype, "companyId", {
    /**
     * The company name the user is currently operating under
     */
    get: function get() {
      return this.$user.companyId;
    },
    enumerable: false,
    configurable: true
  });
  return EndUser;
}();

exports.EndUser = EndUser;